module.exports = __webpack_public_path__ + "static/media/system_flow_id_email.aadd0f0e.svg";